import type { InputHTMLAttributes, ReactNode, Ref } from "react";
import "./checkbox.css";

type Props = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "id" | "type" | "checked" | "onChange" | "aria-describedby"
> & {
  id: string;
  /** Può essere composta (un nome in grassetto e una parte in grigio): tutto il testo è il nome della casella. */
  label: ReactNode;
  checked: boolean;
  onChange: (checked: boolean) => void;
  hint?: string;
  /** L'`id` di un testo scritto altrove che spiega il controllo (per esempio perché è spento). */
  describedBy?: string;
  className?: string;
  /** Arriva all'`<input>` (in React 19 `ref` è una prop). */
  ref?: Ref<HTMLInputElement>;
};

// Etichetta e suggerimento sono fratelli dell'input, non suoi genitori: il nome accessibile è la sola
// etichetta e il suggerimento arriva come descrizione, insieme al motivo scritto altrove.
export function Checkbox({ id, label, checked, onChange, hint, disabled, describedBy, className, ...rest }: Props) {
  const hintId = `${id}-hint`;
  const description = [hint ? hintId : null, describedBy].filter(Boolean).join(" ");
  return (
    <div className={className ? `g-check ${className}` : "g-check"} data-disabled={disabled ? "true" : undefined}>
      <input
        id={id}
        {...rest}
        type="checkbox"
        className="g-check__input"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
        aria-describedby={description || undefined}
      />
      <label className="g-check__label" htmlFor={id}>{label}</label>
      {hint ? <p id={hintId} className="g-check__hint">{hint}</p> : null}
    </div>
  );
}
